export default __webpack_public_path__ + "static/media/S (27).7ae9c51a.png";